<template>
    <div class="content">
        <h3 class="mt-2 mb-5 ml-2 is-hidden-desktop"><i class="fal fa-wine-glass fa-fw mr-3"></i>Menu &amp; Wine</h3>

        <!-- Free-form trip-level notes, shown above the auto-compiled meals. -->
        <div class="white-container content ql-editor" v-if="trip.app_menu" v-html="trip.app_menu"></div>

        <!-- Auto-compiled from the meal events on this itinerary: whatever staff
             entered as Menu and Wines in Roger, plus anything attached to the
             event (menu and wine list PDFs). -->
        <div class="mt-5" v-if="loading">
            <h5 class="has-text-grey"><i class="fal fa-tennis-ball fa-spin mr-3"></i>Gathering menus from the itinerary...</h5>
        </div>
        <div class="mt-5" v-else-if="days.length">
            <div v-for="day in days" :key="day.id" class="mb-5">
                <h5 class="ml-2 mb-4"><i class="far fa-calendar-alt fa-fw mr-2"></i>{{ day.day_on | moment('dddd, MMMM Do YYYY') }}</h5>
                <div class="white-container">
                    <div class="meal" v-for="meal in day.events" :key="meal.type + ':' + meal.id">
                        <h6 class="mb-1"><i class="far fa-utensils fa-fw mr-2"></i>{{ meal.title }}</h6>
                        <div class="meta mb-3">
                            <span v-if="meal.location"><i class="far fa-map-marker fa-fw mr-2"></i>{{ meal.location }}</span>
                            <span class="ml-3" v-if="meal.time"><i class="far fa-clock fa-fw mr-2"></i>{{ meal.time }}</span>
                            <span class="ml-3" v-else-if="meal.start_at"><i class="far fa-clock fa-fw mr-2"></i>{{ meal.start_at | moment('timezone', meal.start_tz, 'h:mm A') }}</span>
                        </div>

                        <div class="detail ql-editor mb-3" v-if="meal.menu">
                            <div class="detail-label">
                                <i class="far fa-utensils fa-fw mr-2"></i>Menu
                                <span class="chosen ml-2" v-if="meal.menu_selected"><i class="far fa-check mr-1"></i>Selected</span>
                            </div>
                            <div v-html="meal.menu"></div>
                        </div>

                        <div class="detail ql-editor mb-3" v-if="meal.wines">
                            <div class="detail-label">
                                <i class="far fa-wine-glass fa-fw mr-2"></i>Wines
                                <span class="chosen ml-2" v-if="meal.wine_selected"><i class="far fa-check mr-1"></i>Selected</span>
                            </div>
                            <div v-html="meal.wines"></div>
                        </div>

                        <event-documents :documents="meal.documents"/>
                    </div>
                </div>
            </div>
        </div>

        <!-- Nothing at all yet -->
        <div class="white-container content has-text-centered" v-if="!loading && !days.length && !trip.app_menu">
            <h4 class="pt-6 pb-6 has-text-grey"><i class="fal fa-message-captions mr-2"></i> More information will be available later.  Check back soon!</h4>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {client as http} from "../../http_client";
    import EventDocuments from "../../components/EventDocuments";

    // Staff-only page. The API gates the meal payload on a staff registration as
    // well — the nav link being staff-only is not the guard.
    export default {
        components: {EventDocuments},
        data: function() {
            return {
                loading: false,
                days: []
            };
        },
        computed: {
            ...mapGetters(['trip', 'registration']),
            isStaff: function() {
                return this.registration.type === 'staff' || this.registration.second_type === 'staff';
            }
        },
        methods: {
            loadMeals: function() {
                if (!this.registration.id || !this.isStaff) return;
                this.loading = true;
                http.get('/app/registrations/' + this.registration.id + '/menu-wine').then(response => {
                    this.days = response.data || [];
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            }
        },
        watch: {
            registration: function() {
                this.loadMeals();
            }
        },
        mounted() {
            this.loadMeals();
        }
    };
</script>

<style lang="scss" scoped>
    .meal {
        border-left: 3px solid #628b21;
        padding-left: 0.7rem;
        padding-bottom: 1.1rem;
        margin-bottom: 1.1rem;
        border-bottom: 1px solid #ededed;

        &:last-child {
            padding-bottom: 0;
            margin-bottom: 0;
            border-bottom: 0;
        }

        h6 {
            font-size: 1rem;
        }
    }

    .detail {
        border: 1px solid #628b21;
        background-color: #f2f6ea;
        border-radius: 8px;
        padding: 0.8rem 1.2rem;
        box-shadow: none;

        .detail-label {
            font-size: 0.75rem;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.03em;
            color: #628b21;
            margin-bottom: 0.4rem;
        }

        .chosen {
            font-size: 0.7rem;
            font-weight: 700;
            text-transform: uppercase;
            letter-spacing: 0.03em;
            color: white;
            background: #628b21;
            border-radius: 10px;
            padding: 0.1rem 0.5rem;
            white-space: nowrap;
        }
    }

    .meta {
        font-size: 0.85rem;
        color: #424242;
    }
</style>
